module.exports = __webpack_public_path__ + "static/media/gear.f0aa4f87.svg";